module.exports = __webpack_public_path__ + "img/scale.2f1095f4.svg";